<template>
  <el-dialog :visible.sync="dialogVisible" :modal="false" :close-on-click-modal="false" class="create-project-dialog" width="60vw">
    <div slot="title" class="dialog-title">
      问题话术<span class="field-alert">（可直接复制发给客户HR或者电话询问）</span>
    </div>
    <p>我们这边会全力以赴来做这个职位，现在有几个问题需要跟您这边再确认一下。</p>
    <br>
    <div v-for="(val, label) in result" :key="label" class="mb10">
      <!-- <p style="font-size:16px;margin-bottom:5px;">{{ label }}</p> -->
      <p v-for="item in val" :key="item" style="padding-left:20px;">{{ item }}</p>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button size="mini" class="mr10" @click="dialogVisible = false">取 消</el-button>
      <el-button size="mini" type="primary" @click="copy">一键复制</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { defaultProject, defaultCompany } from '../../constant/defaultData'

export default {
  props: {
    project: { type: Object, default: () => window._.cloneDeep(defaultProject) },
    company: { type: Object, default: () => window._.cloneDeep(defaultCompany) },
  },
  data() {
    return {
      dialogVisible: false,
      result: {},
      type: {
        项目基本情况: ['招聘数量', '专业职级'],
        人才画像: ['职能模块', '平台', '细分职能', '业绩', '擅长方向', '职级', '目标行业', '地域'],
        寻访方向: ['目标公司', '典型人才', '倾向平台'],
        岗位JD: ['岗位要求', '岗位职责', '核心要求', '岗位薪酬', '关键面试人'],
        客户公司信息: ['公司优势', '职位劣势及风险点'],
        必成单分析: ['职位产生的原因', '最迟到岗日期', '竞争预警'],
        面试辅导: ['面试流程', '面试辅导'],
      },
      sentenceMap: {
        招聘数量: '这个职位预计招聘多少人？',
        专业职级: '这个职位大概可以给到什么职级？',
        人才画像: '这个人选具体会有哪些具体偏好吗？学历呀，风格呀，年限呀等等？',
        目标公司: '这个岗位会不会有领导或者公司层面特别喜欢的平台？',
        典型人才:
          '这个岗位最近会不会有领导看重但offer没谈成的人选，或者是最近这两年领导点过名想要看的人选，大概是什么平台什么背景？',
        倾向平台:
          '这个岗位最近会不会有领导看重但offer没谈成的人选，或者是最近这两年领导点过名想要看的人选，大概是什么平台什么背景？',
        岗位JD: '这个职位有JD吗，可以给我一份吗？',
        岗位要求: '这个职位大概扮演什么样的角色（职责），或者我们对这个人许最核心的要求是什么？',
        岗位职责: '这个职位大概扮演什么样的角色（职责），或者我们对这个人许最核心的要求是什么？',
        核心要求: '这个职位大概扮演什么样的角色（职责），或者我们对这个人许最核心的要求是什么？',
        岗位薪酬:
          '这个岗位我们一般的薪酬参考区间是多少？包括奖金？或：如果要管理候选人对薪酬的预期，你觉得什么范围比较好？',
        关键面试人: '这个岗位会汇报给哪位领导？',
        公司优势: '因为猎头需要对市场上核心的候选人做雇主品牌的传播，有哪些咱们公司核心的亮点一定需要传达到的？',
        职位劣势及风险点: '这个职位大概招了多长时？之前咱们领导看重的人选没来的原因是什么？',
        职位产生的原因: '这个岗位咱们是新增还是替换？',
        最迟到岗日期: '最迟在什么时间之前一定要招到岗？',
        竞争预警: '这个岗位是刚刚开始招吗，还是已经找过一轮了，目前已经也同步放给其他猎头了吗？',
        面试流程: '这次面试一般会有几轮？一般都是哪几位领导？',
        面试辅导: '这轮面试有哪些需要我们辅导人许特别注意的吗？（中后期）',
      },
      special: ['人才画像', '岗位JD'],
    }
  },
  methods: {
    open() {
      this.checkFields()
      this.dialogVisible = true
    },
    checkFields() {
      const { project, type, sentenceMap, special } = this
      const res = {}
      Object.keys(type).forEach(label => {
        res[label] = []
        const fields = type[label]
        if (special.includes(label)) {
          if (label === '人才画像') {
            const flag = this.checkHasValue(fields)
            if (!flag) res[label].push(sentenceMap[label])
          } else if (label === '岗位JD') {
            const flag = this.checkHasValue(fields)
            if (!flag) res[label].push(sentenceMap[label])
            else {
              fields.forEach(field => {
                if (!project[field] && !res[label].includes(sentenceMap[field])) {
                  res[label].push(sentenceMap[field])
                }
              })
            }
          }
        } else {
          fields.forEach(field => {
            if (!project[field] && !res[label].includes(sentenceMap[field])) {
              res[label].push(sentenceMap[field])
            }
          })
        }
      })
      Object.keys(res).forEach(v => {
        if (res[v].length === 0) delete res[v]
      })
      this.result = res
    },
    checkHasValue(fields) {
      let flag = false
      const { project } = this
      fields.forEach(field => {
        if (Array.isArray(project[field])) {
          if (project[field].filter(x => x).length > 0) flag = true
        } else if (project[field]) flag = true
      })
      return flag
    },
    copy() {
      const oTextarea = document.createElement('textarea')
      const { result } = this
      oTextarea.value = `我们这边会全力以赴来做这个职位，现在有几个问题需要跟您这边再确认一下。\n`
      Object.keys(result).forEach(label => {
        // oTextarea.value += `${label}\n`
        const arr = result[label]
        arr.forEach(v => {
          oTextarea.value += `  ${v}\n`
        })
      })
      document.body.appendChild(oTextarea)
      oTextarea.select()
      document.execCommand('Copy')
      document.body.removeChild(oTextarea)
      this.$message.success('复制成功')
    },
  },
}
</script>
<style>
.create-project-dialog .el-dialog__body {
  padding-top: 0px;
}
</style>
<style scoped src="../../css/newCreateProject.css"></style>
<style scoped>
.hasset-field-box {
  display: flex;
  flex-wrap: wrap;
}
.hasset-field {
  flex: none;
  min-width: 100px;
  margin: 10px;
}
.footer-box {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 0;
}
.dialog-title {
  font-size: 16px;
  text-align: left;
  border-bottom: 1px solid #adadad;
  padding-bottom: 8px;
}
.dialog-footer {
  display: flex;
  justify-content: center;
}
.create-project-alert-box {
  border: 1px solid #adadad;
  padding: 10px;
  border-radius: 4px;
}
</style>
